<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer
        dense
        :show-select="bulkMode"
        v-model="selected"
        item-key="code"
        style="white-space: nowrap"
    >
      <template v-slot:top>
        <v-toolbar
          v-if="toolbar"
          flat
          dense
        >
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>

        <div v-if="showBulk && (items.length >= 2)" class="d-flex pl-4 pb-1 align-center">
          <v-checkbox
            v-model="bulkMode"
            hide-details
            :disabled="!items.length"
            class="mt-0 pt-0"
          />

          <v-btn
            x-small
            class="ma-2 white--text"
            color="red"
            :disabled="!bulkMode || !deletableCountLocal"
            @click="bulkRemove"
          >
            Bulk Delete
            <span v-if="deletableCountLocal"> ({{ deletableCountLocal }})</span>
          </v-btn>
        </div>
      </template>
      <template v-if="!readonly" v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>

    <mapkind-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {MapKindLiteModel} from "@/modules/mutils/models/MapKindLiteModel";
import MapkindDialog from "./mapkind-dialog.vue";

export default {
  name: "mapkind-table",
  components: {MapkindDialog},
  props: {
    items: VueTypes.arrayOf(MapKindLiteModel).isRequired,
    title: VueTypes.string.isRequired,
    readonly: VueTypes.bool.def(false),
    toolbar: VueTypes.bool.def(true),
    showBulk: VueTypes.bool.def(true)
  },
  data: () => ({
    headers: [
      {text: 'Name', value: 'key'},
      {text: 'ID', value: 'code'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    selected: [],
    bulkMode: false,
  }),
  computed: {
    empty() {
      return this.items.length === 0;
    },

    deletableCountLocal() {
      return this.selected.length;
    },
  },
  methods: {
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            const index = this.items.indexOf(item);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },

    bulkRemove() {
      if (!this.selected.length) return;

      this.$confirm("Are you sure you want to delete selected items?")
        .then(() => {
          this.selected.forEach(item => {
            const index = this.items.indexOf(item);
            if (index !== -1) {
              this.items.splice(index, 1);
            }
          });
          this.selected = [];
          this.bulkMode = false;
        })
        .catch(() => {});
    },

    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    }
  },

  watch: {
    items(newItems) {
      this.selected = this.selected.filter(v => newItems.includes(v));
    },

    bulkMode(value) {
      if (!value) {
        this.selected = [];
      }
    }
  }
}
</script>